import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "load-wrap ion-text-center"
}
const _hoisted_2 = {
  key: 2,
  class: "ion-padding ion-text-center"
}
const _hoisted_3 = {
  key: 3,
  class: "ion-padding ion-text-center"
}
const _hoisted_4 = {
  key: 4,
  class: "ion-padding ion-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_z_filter = _resolveComponent("z-filter")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_z_pin_list = _resolveComponent("z-pin-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-padding-horizontal white-background-color" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar),
          _createVNode(_component_ion_toolbar, { class: "ion-padding-bottom" }, {
            default: _withCtx(() => [
              _createVNode(_component_z_filter, {
                onFilterActived: _cache[0] || (_cache[0] = ($event: any) => ($options.onFilterChanged($event))),
                title: "My collection",
                module: "collection"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "lds-roller" }, [
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div"),
                    _createElementVNode("div")
                  ], -1),
                  _createElementVNode("p", null, "Loading...", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.pins.length)
              ? (_openBlock(), _createBlock(_component_z_pin_list, {
                  key: 1,
                  module: "collection",
                  pins: _ctx.pins
                }, null, 8, ["pins"]))
              : _createCommentVNode("", true),
            (!_ctx.isLoading && _ctx.pins.length == 0 && $data.activeFilter == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "There are no pins matching your search criteria."))
              : _createCommentVNode("", true),
            (!_ctx.isLoading && _ctx.pins.length == 0 && !$data.activeFilter && !_ctx.biometricSearch.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "There are no pins in your collection yet."))
              : _createCommentVNode("", true),
            (!_ctx.isLoading && _ctx.pins.length == 0 && _ctx.biometricSearch.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No similar pin found. For more accurate results take a photo of the pin on a white background."))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}